import styled from 'styled-components'

const StyledAffiliateDashboard = styled.div`
  padding: 30px 0;

  h1 {
    margin: 0 0 30px 0;
    font-size: 20px;
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.lexend};
    color: ${({ theme }) => theme.colors.gray[700]};
  }
      
  p {
    font-size: 1rem;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.gray[500]};

    a {
      color: ${({ theme }) => theme.colors.green[400]};
      text-decoration: underline;
    }
  }

  .tab-bar {
    box-shadow: inset 0 -2px 0 0 ${({ theme }) => theme.colors.gray[200]};
    margin-right: -20px;
    padding-right: 20px;

    .tab {
      height: 42px;
      font-size: 1rem;
      font-weight: 400;
      padding: 0 2rem;
      border-radius: 3px 3px 0 0;

      &.active {
        color: ${({ theme }) => theme.colors.green[400]};
        background-color: ${({ theme }) => theme.colors.green[50]};
        font-weight: 600;

        &::after {
          background: ${({ theme }) => theme.colors.green[400]};
        }
      }

      &::after {
        height: 2px;
        border-radius: 0;
      }
    }
  }

  .page {
    margin: 25px 0;

    .heading {
      margin-bottom: 25px;
  
      h2 {
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        font-family: ${({ theme }) => theme.fonts.lexend};
        color: ${({ theme }) => theme.colors.gray[700]};

        .qm {
          display: inline-flex;
          margin-left: 10px;
        }
      }
      
      p {
        margin-top: 10px;
      }
    } 
  }

  .disclaimer {
    text-align: center;
    font-size: 12px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .tab-bar {
      margin-right: 0px;
      padding-right: 0px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    padding: 60px 0 10px 0;

    h1 {
      margin: 0 0 40px 0;
    }

    .page {
      margin: 40px 0 80px 0;
    }

    .disclaimer {
      text-align: center;
      font-size: 1rem;
    }
  }
`

export default StyledAffiliateDashboard
